'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HomeRoutes;

var _breadcrumbTpl = require('./breadcrumb.tpl.html');

var _breadcrumbTpl2 = _interopRequireDefault(_breadcrumbTpl);

var _homeTpl = require('./home.tpl.html');

var _homeTpl2 = _interopRequireDefault(_homeTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function HomeRoutes($stateProvider, $breadcrumbProvider) {

    $breadcrumbProvider.setOptions({
        prefixStateName: 'home',
        templateUrl: _breadcrumbTpl2.default
    });

    $stateProvider.state('home', {
        url: '',
        module: 'private',
        auth: ['SYS_ADMIN', 'TENANT_ADMIN', 'CUSTOMER_USER'],
        views: {
            "@": {
                controller: 'HomeController',
                controllerAs: 'vm',
                templateUrl: _homeTpl2.default
            }
        },
        data: {
            pageTitle: 'home.home'
        },
        ncyBreadcrumb: {
            skip: true
        }
    });
}


// WEBPACK FOOTER //
// ./src/app/layout/home.routes.js